// ** Third Party Components
import styled, { css } from "styled-components";

// #####################################################

export const OuterCameraPublishContainer = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	flex-direction: column;
	z-index: 3;
	margin-top: 0.75rem;
	margin-right: 1rem;
	background-color: transparent;
	border: 2px solid #373737;
	background-color: black;
	width: 94px;
	height: 94px;
	overflow: hidden;

	${({ $fullscreen }) =>
		$fullscreen &&
		css`
			min-width: 94px;
			min-height: 94px;
			height: 20vw;
			width: 20vw;
		`}
`;

// #####################################################
